// Hero Text Animation & Scroll Animations (Fixed Header Issue)

(function() {
  'use strict';
  
  // ==========================================
  // 1. Hero Text Animation
  // ==========================================
  
  function initHeroAnimation() {
    // البحث عن نصوص الـ Hero Section
    const heroTitle = document.querySelector('.hero h1, .hero__title, [class*="hero"] h1, .banner__heading, [class*="hero"] .heading');
    const heroSubtitle = document.querySelector('.hero p, .hero__subtitle, [class*="hero"] p, .banner__text');
    const heroButton = document.querySelector('.hero .button, .hero__button, [class*="hero"] .button, .banner__buttons a');
    
    if (heroTitle) {
      heroTitle.style.opacity = '0';
      heroTitle.style.transform = 'scale(0.8) translateY(30px)';
      heroTitle.style.color = 'white';
      heroTitle.style.webkitTextFillColor = 'white';
      
      setTimeout(() => {
        heroTitle.style.transition = 'all 1s cubic-bezier(0.4, 0, 0.2, 1)';
        heroTitle.style.opacity = '1';
        heroTitle.style.transform = 'scale(1) translateY(0)';
      }, 300);
    }
    
    if (heroSubtitle) {
      heroSubtitle.style.opacity = '0';
      heroSubtitle.style.transform = 'translateY(40px)';
      heroSubtitle.style.color = 'white';
      
      setTimeout(() => {
        heroSubtitle.style.transition = 'all 1.2s cubic-bezier(0.4, 0, 0.2, 1)';
        heroSubtitle.style.opacity = '1';
        heroSubtitle.style.transform = 'translateY(0)';
      }, 600);
    }
    
    if (heroButton) {
      heroButton.style.opacity = '0';
      heroButton.style.transform = 'translateY(40px) scale(0.9)';
      
      setTimeout(() => {
        heroButton.style.transition = 'all 1s cubic-bezier(0.4, 0, 0.2, 1)';
        heroButton.style.opacity = '1';
        heroButton.style.transform = 'translateY(0) scale(1)';
      }, 1000);
    }
  }
  
  // ==========================================
  // 2. Scroll Animation للسكشنز (بدون Header)
  // ==========================================
  
  function initScrollAnimations() {
    // استثناء الـ Header تماماً
    const headerSelectors = [
      'header',
      '.header',
      '#shopify-section-header',
      '[data-section-type="header"]',
      '[id*="header"]',
      '.announcement-bar',
      'nav',
      '.navigation'
    ];
    
    // بناء selector يستثني الـ Header
    const excludeHeader = headerSelectors.map(sel => `:not(${sel})`).join('');
    
    // البحث عن كل السكشنز (بدون Hero و Header)
    const sections = document.querySelectorAll(`
      section:not(.hero)${excludeHeader},
      .shopify-section:not([class*="hero"]):not([id*="header"]):not([data-section-type="header"]),
      .featured-collection,
      .collection-list,
      .image-with-text
    `);
    
    // إضافة class للأنيميشن
    sections.forEach(section => {
      // التأكد إنها مش جزء من الـ Header
      if (!section.closest('header') && 
          !section.id?.includes('header') && 
          !section.className?.includes('header')) {
        
        section.classList.add('scroll-animate');
        section.style.opacity = '0';
        section.style.transform = 'translateY(60px)';
      }
    });
    
    // Intersection Observer
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -80px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target.classList.contains('scroll-animate')) {
          entry.target.style.transition = 'all 1s cubic-bezier(0.4, 0, 0.2, 1)';
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          entry.target.classList.add('visible');
          
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    // مراقبة السكشنز فقط
    const animatableSections = document.querySelectorAll('.scroll-animate');
    animatableSections.forEach(section => {
      observer.observe(section);
    });
  }
  
  // ==========================================
  // 3. إصلاح الـ Header (إزالة أي أنيميشن)
  // ==========================================
  
  function fixHeader() {
    const headerElements = document.querySelectorAll(`
      header,
      .header,
      #shopify-section-header,
      [data-section-type="header"],
      [id*="header"],
      .announcement-bar,
      nav,
      .navigation,
      .header-wrapper
    `);
    
    headerElements.forEach(el => {
      // إزالة أي أنيميشن أو تأثيرات
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.animation = 'none';
      el.style.transition = 'none';
      el.classList.remove('scroll-animate');
    });
  }
  
  // ==========================================
  // 4. تهيئة كل الأنيميشن
  // ==========================================
  
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    // إصلاح الـ Header أولاً
    fixHeader();
    
    // تشغيل أنيميشن الـ Hero
    setTimeout(initHeroAnimation, 300);
    
    // تشغيل أنيميشن الـ Scroll
    setTimeout(initScrollAnimations, 100);
    
    // إصلاح الـ Header مرة تانية بعد كل شيء
    setTimeout(fixHeader, 500);
  }
  
  // بدء التنفيذ
  init();
  
})();